import { Component, ComponentRef, HostBinding, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClassType } from '../../../services/typings/class-type';

@Component({
    selector: 'app-modal-container-component-generic',
    imports: [CommonModule],
    templateUrl: './component-wrapper.component.html',
    styleUrl: './component-wrapper.component.scss',
})
export class ComponentWrapperComponent {

    @ViewChild('containerRef', { read: ViewContainerRef, static: true }) containerRef: ViewContainerRef;

    @Input()
    show = true;

    @Input({ required: true })
    modalId: string;

    private _component: ComponentRef<unknown>;

    @HostBinding('class')
    get hostClass() {
        return this.show ? 'block' : 'hidden';
    }

    public createComponent(component: ClassType) {
        return this._component = this.containerRef.createComponent(component);
    }

    get component() {
        return this._component.instance;
    }

}
